function addViewButton(card) {
  if (card.querySelector('.custom-view-btn')) return;

  const link = card.querySelector('a.product-card__link');
  if (!link || !link.href) return;

  card.querySelectorAll('add-to-cart-component, .quick-add, [data-quick-add-button]')
      .forEach(el => el.style.display = 'none');

  const btn = document.createElement('a');
  btn.href = link.href;
  btn.className = 'button button--primary custom-view-btn';
  btn.style = 'display:block; text-align:center; margin-top:8px;';
  btn.textContent = 'Виж продукта';

  const content = card.querySelector('.product-card__content');
  if (content) content.appendChild(btn);
}

document.querySelectorAll('product-card').forEach(addViewButton);

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      if (node.tagName === 'PRODUCT-CARD') {
        addViewButton(node);
      }
      node.querySelectorAll && node.querySelectorAll('product-card').forEach(addViewButton);
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });